import axios from 'axios';
import { publicAPI } from 'services/api/apiUrl';

export const confirmOrder = (id, search) =>
  axios({
    method: 'get',
    url: `${publicAPI}/order/confirm/${id}${search}`,
  });
